/**
 * ユーザデータ.
 * @class
 * @exports
 */
export default class PlanningPatternInfo {
  planningPatternId = null
  blockCode = null
  blockName = null
  planningPatternName = null
  note = null
  deleteImpossibleKind = null
  deleteImpossibleKindName = null
  displayOrder = 0
  displayKind = null
  displayKindName = null
  deleted = null
  registrationTimeDisplay = null
  registrationUser = null
  updateTimeDisplay = null
  updateUser = null
  planningParameters = []
  planningConstraints = []
}
